import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { CirclePlus, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";
import { IItemHistoricoPlano } from "../../../../types";

const detectaServicoAdicionado = (acao: string): boolean => {
  const acaoLower = acao.toLowerCase().trim();
  return acaoLower === 'serviço adicionado' || acaoLower.includes('serviço adicionado');
};

const getIconServicoAdicionado = (acao: string): { Icon: LucideIcon; color: string } => {
  return { Icon: CirclePlus, color: 'var(--c2e86de)' };
};

export default function CardServicoAdicionado({ item, isExpanded, onToggleExpand }: CardHistoricoProps) {
  // Este card é específico para planos, então fazemos type assertion
  const itemPlano = item as IItemHistoricoPlano;
  
  return (
    <CardHistoricoBase
      item={item}
      icon={getIconServicoAdicionado(item.acao)}
      temExpansaoDisponivel={true}
      isExpanded={isExpanded}
      onToggleExpand={onToggleExpand}
      expandedContent={<ExpandedContent item={itemPlano} />}
      tituloCustomizado="Serviço adicionado"
    />
  );
}

export const servicoAdicionadoConfig = {
  tipo: 'servico_adicionado',
  detectaTipo: detectaServicoAdicionado,
  getIcon: getIconServicoAdicionado,
  temExpansao: () => true,
  Component: CardServicoAdicionado
};
